import React, { useState } from 'react';
import './Gallery.css';
import gallery1 from '../../assets/images/mod-4ek-01.jpg';
import gallery2 from '../../assets/images/mod-4ek-02.jpg';
import gallery3 from '../../assets/images/mod-4ek-03.jpg';
import gallery4 from '../../assets/images/mod-4ek-04.jpg';
import gallery5 from '../../assets/images/mod-4ek-05.jpg';
import gallery6 from '../../assets/images/mod-4ek-06.jpg';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { id: 1, src: gallery1, alt: 'Пример чека 1' },
    { id: 2, src: gallery2, alt: 'Пример чека 2' },
    { id: 3, src: gallery3, alt: 'Пример чека 3' },
    { id: 4, src: gallery4, alt: 'Пример чека 4' },
    { id: 5, src: gallery5, alt: 'Пример чека 5' },
    { id: 6, src: gallery6, alt: 'Пример чека 6' }
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <section id="gallery" className="gallery section">
      <div className="container">
        <h2 className="section-title">Примеры чеков, документов</h2>
        <div className="gallery__grid">
          {images.map(image => (
            <div 
              key={image.id} 
              className="gallery__item"
              onClick={() => openModal(image)}
            >
              <img src={image.src} alt={image.alt} className="gallery__image" />
            </div>
          ))}
        </div>
      </div>

      {/* Модальное окно для просмотра изображения */}
      {selectedImage && (
        <div className="gallery__modal" onClick={closeModal}>
          <div className="gallery__modal-content" onClick={e => e.stopPropagation()}>
            <button className="gallery__modal-close" onClick={closeModal}>×</button>
            <img src={selectedImage.src} alt={selectedImage.alt} className="gallery__modal-image" />
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;